// Posição de cada componente sobre a ilustração (% do container) e de que lado
// o rótulo fica. Compartilhado pelo card da Visão Geral e pelo mapa completo.
export const PART_LAYOUT = {
  'Hélice':        { top: '6%',  left: '50%', side: 'top' },
  'Motor':         { top: '27%', left: '38%', side: 'left' },
  'Aviônicos':     { top: '27%', left: '62%', side: 'right' },
  'Asas':          { top: '60%', left: '27%', side: 'left' },
  'Fuselagem':     { top: '55%', left: '73%', side: 'right' },
  'Trem de pouso': { top: '85%', left: '62%', side: 'right' },
}

// Deslocamento do rótulo conforme o lado, para o ponto ficar centrado.
export const labelTransform = (side) =>
  side === 'left'
    ? 'translate(-100%, -50%)'
    : side === 'top'
      ? 'translate(-50%, -50%)'
      : 'translate(0, -50%)'

// Mapa completo: coordenadas no sistema da silhueta (200×150), com folga
// lateral no viewBox para os rótulos. `anchor` é o ponto sobre a peça,
// `label` onde o texto fica, e a linha-guia liga os dois.
export const PART_CALLOUTS = {
  'Hélice':        { anchor: [100, 16], label: [100, -4],  align: 'middle' },
  'Motor':         { anchor: [98, 46],  label: [4, 44],    align: 'end' },
  'Aviônicos':     { anchor: [107, 38], label: [196, 34],  align: 'start' },
  'Asas':          { anchor: [44, 84],  label: [-10, 96],  align: 'end' },
  'Fuselagem':     { anchor: [104, 98], label: [196, 106], align: 'start' },
  'Trem de pouso': { anchor: [82, 90],  label: [-10, 132], align: 'end' },
}

// Onde a linha-guia encosta no texto, para não cruzar as letras.
export const calloutStart = ([x, y], align) =>
  align === 'end' ? [x + 5, y - 1] : align === 'start' ? [x - 5, y - 1] : [x, y + 4]
